import { useMediaQuery, useTheme } from '@mui/material';

import { useAuth } from '@hooks';

import {
  PartnerCompanySummaryDesktop,
  PartnerCompanySummaryMobile,
} from './components';

export function CompanySummary() {
  const { currentCompany } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (!currentCompany) return null;

  if (isMobile) {
    return <PartnerCompanySummaryMobile />;
  }

  return <PartnerCompanySummaryDesktop />;
}
